import { Component, Input } from '@angular/core';
import { VgMuteComponent } from '@videogular/ngx-videogular/controls';


@Component({
    selector: 'vg-mute-extended',
    template: `
    <button type="button"
      class="iconButton"
      [class.vgMute]="isMuted"
      [class.vgUnmute]="!isMuted"
      (click)="onClick()"
    ></button>
  `,
})
export class VgMuteExtendedComponent extends VgMuteComponent {
    @Input() volume!: number;
    override currentVolume: number = 1;
    public isMuted: boolean = false;
    override API: any;

    override onClick() {
        this.currentVolume = this.currentVolume ?? this.API?.volume ?? 1;
        this.isMuted = !this.isMuted;
        this.API?.setVolume(this.isMuted ? 0 : this.currentVolume);
    }
}